import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./_input-file.component.sass'],
})
export class InputFileComponent implements OnDestroy {
  @Input() tradeId: string;
  @Input() name: string;
  @Input() value: any;
  @Input() icon: string;
  @Input() label: string;
  @Input() nameButton: string;
  @Input() id: string;
  @Input() type: string;
  @Input() accept: string;
  @Input() isManual: string;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;

  progress = 0;
  private subscriptions = new Subscription();

  public inputModel: any;
  public inputValue: any;

  public fileAttr = '';
  public dataImage: any;
  public tempValue = 'Selecione o arquivo';

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  upload(event: any) {
    const [targetFile] = event?.target?.files;

    if (targetFile) {
      this.fileAttr = '';
      Array.from(event.target.files).forEach((file: File) => {
        this.fileAttr += file.name;
      });

      this.inputModel = this.fileAttr;
    }
  }
}
